import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import the centralized config

const D01BarChartViz02 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by business unit (demographic_category_02 in the new JSON)
    const DepartmentCounts = filteredData.reduce((acc, item) => {
      const Department = item.demographic_category_02; // Use demographic_category_02 for Business Unit
      if (!acc[Department]) {
        acc[Department] = 0;
      }
      acc[Department]++;
      return acc;
    }, {});

    // Sort business units alphabetically
    const DepartmentNames = Object.keys(DepartmentCounts).sort((a, b) =>
      a.localeCompare(b)
    );
    const chartData = DepartmentNames.map(
      (Department) => DepartmentCounts[Department]
    );

    // Update state
    setCategories(DepartmentNames);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25; // Set height for each bar
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * DepartmentNames.length,
      barHeight * minBars
    ); // Total height based on the number of bars

    // Chart options
    const optionsViz02 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight, // Dynamically set height based on the number of bars
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 28,
        style: {
          colors: ["#000"],
        },
      },
      xaxis: {
        categories: DepartmentNames,
      },
    };

    // Render the chart
    const viz02 = new ApexCharts(
      document.querySelector("#viz-02"),
      optionsViz02
    );
    viz02.render();

    // Cleanup chart on component unmount
    return () => {
      viz02.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", height: "100%", overflowY: "auto" }}>
      {" "}
      {/* Enable scrolling */}
      <div id="viz-02"></div>
    </div>
  );
};

export default D01BarChartViz02;
